import actionCreatorFactory from 'typescript-fsa';
import { Informations } from '../models/Information';

const actionCreator = actionCreatorFactory('App');

export const AppActions = {
    setHeaderInformation: actionCreator<Informations>('setHeaderInformation'),
    setSelectedTabIndex: actionCreator<number>('setSelectedTabIndex'),
}